var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.227 4.017) scale(1.0301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5.25008L9.75 10.2501M9.75 5.25008L4.75 10.2501M17.2422 9.70468L14.3108 13.5047C13.9582 13.9616 13.782 14.1901 13.5607 14.3548C13.3646 14.5006 13.1435 14.6093 12.9083 14.6754C12.6428 14.7501 12.3542 14.7501 11.7771 14.7501H3.95C2.82989 14.7501 2.26984 14.7501 1.84202 14.5321C1.46569 14.3404 1.15973 14.0344 0.967991 13.6581C0.750001 13.2303 0.750001 12.6702 0.750001 11.5501V3.95008C0.750001 2.82998 0.750001 2.26992 0.967991 1.8421C1.15973 1.46577 1.46569 1.15981 1.84202 0.968066C2.26984 0.750076 2.82989 0.750076 3.95 0.750076H11.7771C12.3542 0.750076 12.6428 0.750076 12.9083 0.824746C13.1435 0.890886 13.3646 0.999576 13.5607 1.14542C13.782 1.31006 13.9582 1.53854 14.3108 1.99551L17.2422 5.79548C17.7818 6.49498 18.0516 6.84478 18.1554 7.23048C18.2469 7.57078 18.2469 7.92938 18.1554 8.26968C18.0516 8.65538 17.7818 9.00518 17.2422 9.70468Z",
    stroke: "currentColor",
    strokeWidth: 1.456,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.652c8c6f19e15f0f4ff98a2164527a7b.svg";
export { ForwardRef as ReactComponent };